import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);
import { TranslateService } from "@ngx-translate/core";
import { DashboardItemType } from "../bfx-common/models/dashboard-item-type.enum";
import { GoldenLayoutAdditionMode } from "../golden-layout/golden-layout-addition-mode";
import {
  GLPopoutConfiguration,
  GLPopoutState,
  GLPopoutUndockBehaviour,
  GoldenLayoutService,
} from "../golden-layout/golden-layout-service";
import { BfxHedgeOrderMonitorComponentData } from "./bfx-hedge-order-monitor.component";

export class BfxHedgeOrderMonitorComponentLauncher {
  /**
   * Launches a new instance of the hedge order monitor window
   * @param data contains active fixing data
   * @param layoutService golden layout service instance
   * @param translationService ngx translation service instance
   */
  public static launchHedgeOrderMonitor(
    data: BfxHedgeOrderMonitorComponentData,
    layoutService: GoldenLayoutService,
    translationService: TranslateService,
    event: any,
  ): void {
    if (data.bmarkSummaryData.activeFixingData != null) {
      try {
        let activeFixingTitle: string = `${data.bmarkSummaryData.activeFixingData.displayCode} ${data.bmarkSummaryData.activeFixingData.displayTime} (${data.bmarkSummaryData.activeFixingData.displayDate})`;
        let title: string =
          translationService.instant("hedge_order_monitor.window.title") +
          " - " +
          activeFixingTitle;

        let config: GLPopoutConfiguration = new GLPopoutConfiguration();

        config.initialState = GLPopoutState.POPOUT;
        config.undockBehaviour = GLPopoutUndockBehaviour.APPLY_BOUNDING_SIZE;
        config.popoutResizable = true;
        config.preferredSize = { width: 1000, height: 660 };
        config.minimumSize = { width: 1000, height: 660 };
        config.data = data;
        config.sourceEvent = event && event.sourceEvent ? event.sourceEvent : event;

        layoutService.launchFromDashboard(
          title,
          DashboardItemType.HedgeOrderMonitor,
          true,
          GoldenLayoutAdditionMode.DEFAULT,
          config,
        );
      } catch (error) {
        logger.out.error(
          `BfxHedgeOrderMonitorComponentLauncher.launchHedgeOrderMonitor: ${error} `,
          error,
        );
      }
    }
  }
}
